import template from './footer.html';
import controller from './footer.controller';

let footerComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default footerComponent;



// WEBPACK FOOTER //
// ./client/app/layout/footer.component.js